import { combineReducers, configureStore } from "@reduxjs/toolkit";

import { persistReducer, persistStore } from "redux-persist";
import UserSlice from "./features/user/UserSlice";
import studentReducer from "./features/student/StudentSlice";
import groupReducer from "./features/group-houses/GroupSlice";
import classesReducer from "./features/classes/ClassesSlice";
import staffReducer from "./features/staff/staffSlice";
import queryReducer from "./features/query/QuerySlice";
import schoolBranchReducer from "./features/school-branch-controller/schoolBranchSlice";
import formReducer from "./features/forms/FormSlice";
import admissionReducer from "./features/admission/admissionSlice"
import examsReducer from "./features/exam/ExamSlice"
import helpDeskReducer from "./features/help-desk/HelpDeskSlice"
import { assignmentReducer } from "./features/assignment/assignmentSlice";
import ptmReducer from "./features/ptm/PtmSlice"
import feesAndPaymentReducer from "./features/feesAndPayment/FeesAndPaymentSlice"
import accessReducer from "./features/access-controller/AccessController"
import dashboardReducer from "./features/dashboard/dashboardSlice"
import messagesReducer from "./features/message-controller/messageSlice";
import leaveRequestReducer from "./features/leave-request/leaveRequestSlice";
import attenderReducer from "./features/attender-controller/attenderSlice";

import sessionStorage from "redux-persist/lib/storage/session";
import { submissionReducer } from "./features/assignment-submission/assignmentSubmissionSlice";

// import storage from "redux-persist/lib/storage"; 

const persitConfig = {
  key: "root",
  version: 1,
  storage: sessionStorage,
};

const reducer = combineReducers({
  user: UserSlice,
  student: studentReducer,
  group: groupReducer,
  classes: classesReducer,
  staff: staffReducer,
  query: queryReducer,
  schoolBranch: schoolBranchReducer,
  forms: formReducer,
  admissions: admissionReducer,
  exams: examsReducer,
  helpDesk: helpDeskReducer,
  assignment: assignmentReducer,
  ptm: ptmReducer,
  fees: feesAndPaymentReducer,
  access: accessReducer,
  dashboard: dashboardReducer,
  messages: messagesReducer,
  leaveRequest: leaveRequestReducer,
  attender: attenderReducer,
  submission: submissionReducer
});
const persistedReducer = persistReducer(persitConfig, reducer);
export const store = configureStore({
  reducer: persistedReducer,
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
